export default __webpack_public_path__ + "static/Deployment-942f986977ef4d4682afd00c0a9d8729.webp";